import HttpRequest from "@/plugins/axios";

class DataSyncProvider extends HttpRequest {
    constructor() {
        super(process.env.VUE_APP_API_URL);
    }

    async createStudentsFromMasterRegAdmission(info) {
        const { data } = await this.post("/", {
            function: "create-students-from-master-reg-admission",
            LEVEL_ID: info.LEVEL_ID,
            ADMIT_YEAR: info.ADMIT_YEAR,
            ADMIT_TERM: info.ADMIT_TERM,
            REGISTER_ID: info.REGISTER_ID,
        });
        return data;
    }

    async createStudentsToRegistrar(info) {
        const { data } = await this.post("/", {
            function: "create-students-to-registrar",
            LEVEL_ID: info.LEVEL_ID,
            ADMIT_YEAR: info.ADMIT_YEAR,
            ADMIT_TERM: info.ADMIT_TERM,
            STUDENT_ID: info.STUDENT_ID,
        });
        return data;
    }

    async getRegistrarStudentInfoById(apply_id) {
        const { data } = await this.get("/", {
            function: "get-registrar-student-info-by-id",
            register_id: apply_id,
        });
        return data;
    }

    async getRegistrarStudentInfoByStudentID(student_id) {
        const { data } = await this.get("/", {
            function: "get-registrar-student-info-by-student-id",
            student_id: student_id,
        });
        return data;
    }
}

export default DataSyncProvider;